import { generatePath, useLoaderData, useLocation, useNavigate } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { SubscriptionCategory } from '../../../../../common/enums.js';
import { useGetServiceFeeSim } from '../../../../../common/hooks/useGetServiceFeeSim';
import { activateSimCardMsg, internetSubscriptionsMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n';
import { getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { SimActivation } from '../../../../../components/SimActivation/SimActivation.js';
import type { BroadbandSubPostChangeRequestLoaderResponse } from '../../../../../common/loaders';

export const BroadbandSubActivateSimPath = () => {
  const { companyInfo, hasPendingActions, subscription } =
    useLoaderData() as BroadbandSubPostChangeRequestLoaderResponse;
  const getServiceFeeSim = useGetServiceFeeSim();
  const { search } = useLocation();
  const navigate = useNavigate();

  return (
    <SimActivation
      breadCrumbs={
        <BreadCrumbsWithTitle
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.SEYV(internetSubscriptionsMsg), path: paths.PS_BROADBAND_SUBSCRIPTIONS },
            {
              name: subscription.subscriptionId,
              path:
                generatePath(paths.PS_BROADBAND_SUBSCRIPTION, {
                  subscriptionId: getSubscriptionUrlId(subscription),
                }) + search,
            },
            { name: t.M1E7(activateSimCardMsg) },
          ]}
        />
      }
      category={SubscriptionCategory.BROADBAND}
      companyInfo={companyInfo}
      disallowBillableSimChanges={false}
      getServiceFeeSim={getServiceFeeSim}
      hasPendingActions={hasPendingActions}
      onClickOrderSim={() =>
        navigate(
          generatePath(paths.PS_BROADBAND_SUBSCRIPTION_ORDER_SIM, {
            subscriptionId: getSubscriptionUrlId(subscription),
          }) + search
        )
      }
      onClickSubscription={() => {
        navigate(
          generatePath(paths.PS_BROADBAND_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) + search
        );
      }}
      subscription={subscription}
    />
  );
};
